import api from './api';

// Kept out of lib/api.js deliberately, same posture as
// adminInvoicePayerBackfillApi.js: that file is edited concurrently by
// other sessions, and this is the only call site this card needs. Reuses
// api's shared axios instance (baseURL, auth interceptor) unchanged.
//
// Both actions are out-of-band (202 + job id, JobStore-backed -- CLAUDE.md
// Prompt G asked for the same shape as the invoice payer/payment-date
// backfill card). The per-receipt trace is keyed by invoice_id so tracing
// two different receipts never collides on "already running".
export const adminReceiptPaidTraceAPI = {
  traceStart: (invoiceId) => api.post('/admin/diagnostics/receipt-paid-trace/start', { invoice_id: invoiceId }),
  traceJobStatus: (jobId) => api.get(`/admin/diagnostics/receipt-paid-trace/job-status/${jobId}`),
  traceJobLatest: (invoiceId) => api.get('/admin/diagnostics/receipt-paid-trace/job-latest', { params: { invoice_id: invoiceId } }),

  funnelSummaryStart: () => api.post('/admin/diagnostics/receipt-paid-trace/funnel-summary/start'),
  funnelSummaryJobStatus: (jobId) => api.get(`/admin/diagnostics/receipt-paid-trace/funnel-summary/job-status/${jobId}`),
  funnelSummaryJobLatest: () => api.get('/admin/diagnostics/receipt-paid-trace/funnel-summary/job-latest'),
};
